<script>
import PftPlageSelector from "@/containers/pft-plage-selector";
import RateStar from "@/components/atoms/rate-star";
import Price from "@/components/molecules/price";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Divider from "@/components/atoms/divider";
import Badge from "@/components/atoms/badge";
import EnergyClass from "@/components/molecules/energy-class";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import NutriScore from "@/components/molecules/nutri-score";
import LinkTo from "@/components/atoms/link-to";
import PopinTraiteurDeFetes from "@/containers/popin-traiteur-de-fetes";
import PopinTraiteurPermanent from "@/containers/popin-traiteur-permanent";
import BadgeBoutique from "@/containers/badge-boutique";
import Titre from "@/components/atoms/titre";
import {
  productDetailsEmits,
  productDetailsProps,
  useProductDetails
} from "@/components/organisms/product-sheet/product-details/mixin";
import Container from "@/components/atoms/container";
import ProductVariantDetails from "@/containers/product-sheet/product-details-variant";
import ImageProductViewer from "@/components/organisms/product-sheet/image-product-viewer/default";
import ItemContainer from "@/containers/panier/item";
import AdvantagesContainer from "@/containers/avantages";
import ShippingMethodEligibility from "@/containers/shipping-method-eligibility";
import ButtonIcon from "@/components/molecules/button-icon/index";
import Alert from "@/components/molecules/alert";
import IndiceReparabilite from "@/components/molecules/indice-reparabilite";
import ReassuranceDLC from "@/components/organisms/reassurance-dlc";
import Popin from "@/components/molecules/popin";
import BandeauTraiteurFete from "@/components/organisms/merch-traiteur-fete/bandeau-fp";
import BandeauTraiteurPermanent from "@/components/organisms/merch-traiteur-permanent/bandeau-fp";
import PopinAnchor from "@/components/molecules/popin-anchor";
import CmsFetcher from "@/containers/cms-fetcher";
import BadgePoids from "@/components/molecules/badge-poids";
import CarteKdoMontant from "@/components/organisms/product-sheet/carte-kdo-montant";
import ProductDetailsMultipay from "@/containers/product-sheet/product-details-multipay";
import { useProductSheetBreadcrumb } from "../mixins/product-sheet-breadcrumb.mixin";
import { useProductListItem } from "@/components/organisms/mixins/product-list-item-mixin";

import alertShippingLad from "@/assets/images/livraison/ldd/alert-shipping-lad.svg";
import primeEnergie from "@/assets/images/prime-energie.png";
import consigne from "@/assets/images/Consigne@2x.png";

export default {
  name: "ProductDetails",
  components: {
    Icon,
    CarteKdoMontant,
    PftPlageSelector,
    List,
    LinkTo,
    NutriScore,
    ListItem,
    RateStar,
    Price,
    Button,
    Badge,
    BadgePoids,
    LazyImage,
    Divider,
    EnergyClass,
    PopinTraiteurDeFetes,
    PopinTraiteurPermanent,
    Container,
    ItemContainer,
    ProductVariantDetails,
    ShippingMethodEligibility,
    ImageProductViewer,
    AdvantagesContainer,
    ButtonIcon,
    Alert,
    IndiceReparabilite,
    BandeauTraiteurFete,
    BandeauTraiteurPermanent,
    ReassuranceDLC,
    Popin,
    PopinAnchor,
    CmsFetcher,
    ProductDetailsMultipay,
    BadgeBoutique,
    Titre
  },
  props: {
    ...productDetailsProps()
  },
  emits: ["openOrcloseStoreLocator", ...productDetailsEmits()],
  setup(props, context) {
    const { parentLevel } = useProductSheetBreadcrumb(props);

    const {
      showPlanningClickCollectTraiteur,
      showPlanningClickCollectTraiteurNoel,
      AddToPurchaseList,
      dpClickAndCollectTraiteurUrl,
      dpClickAndCollectTraiteurNoelUrl,
      isPft,
      isPrimeMarche,
      isPrimeBio,
      isMardiPass,
      getIconPrime,
      amount,
      discountedAmount,
      discountRate,
      pricePerUnit,
      uniteRef,
      characteristicsStickers,
      showGarantieLegale,
      isClickAndCollectTraiteur,
      isClickAndCollectTraiteurNoel,
      isLdd,
      variantEnStock,
      isNotEligibleClickAndCollect,
      isNotEligibleLdd,
      showShippingMethodEligibility,
      indexPoidsChanged,
      formattedPrice,
      getNutriScoreClassName,
      url,
      trackingCtaMarque,
      variantCodes,
      productDetailsCodes,
      commercialStickerCodes,
      prixCKDO,
      isCarteKdo,
      isBuffet
    } = useProductDetails(props, context);

    const { hasUnitReference, hasInfoConso, showProductBadge } =
      useProductListItem({
        article: props.product,
        isNational: props.isNational
      });

    const ProductAdvantages = defineAsyncComponent(() =>
      import("@/components/organisms/product-sheet/product-advantages")
    );
    const AddToCart = defineAsyncComponent(() =>
      import("@/components/organisms/product-sheet/add-to-cart/default")
    );
    return {
      showProductBadge,
      hasUnitReference,
      hasInfoConso,
      ProductAdvantages,
      AddToCart,
      parentLevel,
      showPlanningClickCollectTraiteur,
      showPlanningClickCollectTraiteurNoel,
      AddToPurchaseList,
      dpClickAndCollectTraiteurUrl,
      dpClickAndCollectTraiteurNoelUrl,
      isPft,
      amount,
      discountedAmount,
      discountRate,
      pricePerUnit,
      uniteRef,
      characteristicsStickers,
      showGarantieLegale,
      isClickAndCollectTraiteur,
      isClickAndCollectTraiteurNoel,
      isLdd,
      variantEnStock,
      isNotEligibleClickAndCollect,
      isNotEligibleLdd,
      showShippingMethodEligibility,
      indexPoidsChanged,
      formattedPrice,
      getNutriScoreClassName,
      url,
      trackingCtaMarque,
      variantCodes,
      productDetailsCodes,
      commercialStickerCodes,
      alertShippingLad,
      primeEnergie,
      consigne,
      prixCKDO,
      isCarteKdo,
      isPrimeMarche,
      isPrimeBio,
      isMardiPass,
      getIconPrime,
      isBuffet
    };
  },
  methods: {
    setPriceCkdo({ price, isInputtedPrice }) {
      this.prixCKDO = price;
      this.$nextTick(() => {
        this.$refs.itemContainer.setQuantity(
          1,
          null,
          isInputtedPrice ? "montant choisi" : "montant prédéfini"
        );
        this.prixCKDO = null;
      });
    },
    truncatedText(text, maxlength) {
      // fonction qui permet de tronquer le texte a un nombre caractérre donné
      return text && text.length > maxlength
        ? `${text.substr(0, maxlength - 1)}...`
        : text;
    },
    scrollTo(targetId) {
      const target = document.getElementById(targetId);
      if (!target) {
        return;
      }
      const targetOffsetTop = target.offsetTop;
      if (this.isPopin) {
        document
          .getElementById(targetId)
          .scrollIntoView({ top: targetOffsetTop + 50, behavior: "smooth" });
      } else {
        window.scrollTo({
          top: targetOffsetTop + 50,
          left: 0,
          behavior: "smooth"
        });
      }
    }
  }
};
</script>

<template>
  <Container class="c-product-detail">
    <PopinTraiteurDeFetes
      :show-planning-click-collect-traiteur="showPlanningClickCollectTraiteurNoel"
      @closed="showPlanningClickCollectTraiteurNoel=false"
    />
    <PopinTraiteurPermanent
      :visible="showPlanningClickCollectTraiteur"
      @closed="showPlanningClickCollectTraiteur=false"
    />

    <div class="u-flex u-gap-lg">
      <ImageProductViewer
        v-if="product.attributes.photos && product.attributes.photos.length > 0"
        :images="photos"
        :product-name="product.attributes.designation"
        class="c-product-detail__image"
        :picto-principal="product.attributes.picto_principal"
      />
      <div class="u-flex-item-fluid">
        <div
          v-if="showProductBadge"
          class="u-mb-sm u-flex u-flex-wrap u-gap-xxs"
        >
          <BadgeBoutique
            :article="product"
            :url="firstLevelBreadcrumb ? firstLevelBreadcrumb.route : null"
            is-fp
          />
        </div>
        <component
          :is="product.attributes.url_marque ? 'LinkTo' : 'div'"
          v-if="product.attributes.marque && product.attributes.marque !== productDetailsCodes.SANS_MARQUE"
          :href="product.attributes.url_marque"
          size="md"
          variant="text-light"
          no-underline
          class="u-text-uppercase u-mb-xs"
          @click="trackingCtaMarque()"
        >
          {{ product.attributes.marque }}
        </component>

        <h1
          v-if="product.attributes.designation"
          class="u-font-24 u-font-700 u-mb-xs"
        >
          {{ product.attributes.designation }}
        </h1>
        <div class="u-flex u-gap-sm">
          <BadgePoids
            :article="product"
            :has-unit-reference="hasUnitReference"
            :has-info-conso="hasInfoConso"
          />
          <div
            v-if="product.attributes.reviews_count > 0"
            @click="scrollTo('avis-clients')"
          >
            <RateStar
              :id="product.id"
              :score="parseFloat(product.attributes.review_rate)"
              :max="5"
              icon-size="xs"
              :count="product.attributes.reviews_count"
              disable-score
              class="c-product-detail__rate-star"
            />
          </div>
        </div>
        <p
          v-if="product.attributes.description || product.attributes.garantie_legale"
          class="u-font-15 u-color-text-light u-mt-xs u-mb-xs25"
        >
          <span v-html="truncatedText(product.attributes.description, productDetailsCodes.DESCRIPTON_MAX_LENGTH)" />
          <template v-if="showGarantieLegale">
            <br /><br />
            <span class="u-font-15 u-font-500">
              Garantie légale : </span>
            <span> {{ product.attributes.garantie_legale }}
            </span>
          </template>
          <Button
            v-if="product.attributes.description && product.attributes.description.length > productDetailsCodes.DESCRIPTON_MAX_LENGTH"
            link
            @click="scrollTo('description')"
          >
            Voir la description détaillée
          </Button>
        </p>

        <BandeauTraiteurFete
          v-if="isClickAndCollectTraiteurNoel"
          class="u-my-md"
          @click="showPlanningClickCollectTraiteurNoel = true"
        />
        <BandeauTraiteurPermanent
          v-if="isClickAndCollectTraiteur || isBuffet"
          class="u-my-md"
          @click="showPlanningClickCollectTraiteur = true"
        />
        <div v-if="!product.attributes.is_variant">
          <div class="u-flex u-flex-align-center u-flex-wrap u-gap-md">
            <EnergyClass
              v-if="product.attributes.classe_energetique"
              class="u-mr-xlg u-mr-none@lg"
              :classe-energetique="product.attributes.classe_energetique"
              show-link
            />
            <IndiceReparabilite
              v-if="product.attributes.indice_reparabilite && product.attributes.indice_reparabilite.value"
              class="u-full-height"
              :score="product.attributes.indice_reparabilite.value"
              :pdf="product.attributes.indice_reparabilite.url"
            />
          </div>
          <template v-if="product.attributes.product_list_item_features!== null && product.attributes.product_list_item_features.length > 0">
            <p class="u-mt-md u-mb-xs u-font-700">
              Points forts
            </p>
            <List :class="product.attributes.product_list_item_features.length > 3 ?'c-product-detail__features' : ''">
              <template
                v-for="(feature, i) in product.attributes.product_list_item_features"
                :key="feature.label"
              >
                <ListItem
                  v-if="i < 6"
                  class="c-product-detail__feature"
                >
                  {{ feature.label }} : {{ feature.value }}
                </ListItem>
              </template>
            </List>
          </template>
        </div>

        <div class="u-flex u-flex-align-center u-flex-justify-center u-mb-sm">
          <ButtonIcon
            v-if="product.attributes.features && product.attributes.features.length > 0"
            icon-name="arrow-down"
            outline
            size="sm"
            icon-size="xs"
            icon-position="right"
            radius="full"
            variant="primary"
            icon-color="primary"
            @click="scrollTo('characteristics')"
          >
            Voir les caractéristiques
          </ButtonIcon>
        </div>

        <div
          v-if="isPrimeMarche || isPrimeBio || isMardiPass"
          class="c-product-avantage-encart"
        >
          <div class="u-flex u-flex-align-center u-mb-xs">
            <Icon
              :name="getIconPrime"
              size="md"
              class="u-mr-xs"
            />
            <Titre
              tag="h1"
              size="sm"
            >
              <template v-if="isMardiPass">
                -15% Mardi PASS
              </template>
              <template v-else-if="isPrimeMarche || isPrimeBio">
                -10% CLUB
              </template>
            </Titre>
          </div>
          <p>
            <template v-if="isMardiPass">
              15% cagnottés sur tous les produits de marques Carrefour pour toute commande passée pendant la Journée PASS de votre magasin en payant avec votre Carte PASS !
            </template>
            <template v-else-if="isPrimeMarche">
              -10% tous les jours sur tous les Fruits et Légumes ou -15% en payant avec la carte PASS. Avantage à activer dans votre espace “Mon Club Carrefour”
            </template>
            <template v-else-if="isPrimeBio">
              -10% tous les jours sur tous les produits Carrefour Bio ou -15% en payant avec la carte PASS. Avantage à activer dans votre espace “Mon Club Carrefour”
            </template>
          </p>
          <LinkTo
            v-if="!isMardiPass"
            class="u-mt-xs u-color-primary"
            to="https://www.carrefour.fr/mon-compte/fidelite/mes-primes"
            target="_blank"
            variant="primary"
            no-underline
          >
            Activez vos avantages
          </LinkTo>
        </div>

        <Alert
          v-if="product.attributes.infos_vendeur"
          class="u-mb-md"
        >
          <div class="u-flex">
            <div class="u-mr-sm">
              <LazyImage
                :src="alertShippingLad"
                class="u-flex-shrink-none"
                height="56"
                width="56"
                alt=""
              />
            </div>
            <div class="u-pt-xs">
              <p class="u-font-500 u-font-17 u-mb-xs">
                Disponible uniquement à la livraison à domicile
              </p>
              <p>Livraison sous {{ product.attributes.infos_vendeur.delai_livraison }} jours ouvrés à compter de la validation de votre commande</p>
              <div class="u-mt-xxs">
                <PopinAnchor
                  link
                  variant="primary"
                  popin-size="md"
                  position="bottom-right"
                  open-on-hover
                  radius="md"
                  class="u-mr-sm"
                >
                  <template #button-content>
                    <span class="u-font-15">Voir les conditions particulières de livraison</span>
                  </template>
                  <p class="u-font-secondary u-font-15 u-font-700 u-mb-xs">
                    Conditions particulières de livraison
                  </p>
                  <p class="u-font-13">
                    {{ product.attributes.infos_vendeur.conditions_livraison }}
                  </p>
                </PopinAnchor>
                <Button
                  link
                  variant="primary"
                  @click="$refs.lddInfoPopin.show()"
                >
                  <span class="u-font-15">En savoir plus</span>
                </Button>
                <Popin
                  ref="lddInfoPopin"
                  size="lg"
                  aria-label="Informations LDD"
                >
                  <CmsFetcher link="/infos-et-services/sinformer/exclus-web" />
                </Popin>
              </div>
            </div>
          </div>
        </Alert>
        <Divider dotted />
        <ProductVariantDetails
          v-if="variantEnStock && product.attributes.type === variantCodes.TC"
          :product-info="product.attributes"
        />

        <div class="u-flex u-my-md u-flex-column@md u-gap-sm">
          <div
            v-if="!product.attributes.produit_non_vendable && isNational && (!product.attributes.prix || product.attributes.prix === null || product.attributes.prix === '0.00' ) || (isNotEligibleClickAndCollect && isNational)"
            class="u-radius-md u-bgcolor-bg u-flex-item-fluid u-p-md"
          >
            <p class="u-font-18 u-font-500 u-text-center">
              Consulter la disponibilité et le prix de ce produit<br>
              dans le magasin le plus proche de chez vous.
            </p>
            <div class="c-product-detail__store-availability-buttons">
              <client-only>
                <ItemContainer
                  :article="product"
                  :component="AddToPurchaseList"
                  :from-prospectus="fromProspectus"
                  class="u-mr-xlg"
                />
              </client-only>
              <Button
                variant="primary"
                radius="full"
                size="sm"
                @click="$emit('openOrcloseStoreLocator')"
              >
                Choisir un magasin
              </Button>
            </div>
          </div>

          <div
            v-else-if="!product.attributes.en_stock && !isNational || isNotEligibleClickAndCollect || isNotEligibleLdd || isReplacedByNational"
            class="u-radius-md u-bgcolor-bg u-flex-item-fluid u-p-md"
          >
            <p class="u-font-18 u-font-500 u-text-center">
              <template v-if="isReplacedByNational">
                Ce produit n'est pas disponible dans votre magasin
              </template>
              <template v-else>
                Ce produit sera bientôt disponible
              </template>
            </p>
            <div class="c-product-detail__store-availability-buttons">
              <client-only v-if="!isCarteKdo">
                <ItemContainer
                  :article="product"
                  :component="AddToPurchaseList"
                  :from-prospectus="fromProspectus"
                  class="u-mr-lg"
                />
              </client-only>

              <Button
                :to="parentLevel"
                variant="primary"
                radius="full"
                size="md"
              >
                Voir les produits similaires
              </Button>
            </div>
            <p class="u-text-center u-mt-md">
              <Button
                link
                @click="$emit('openOrcloseStoreLocator')"
              >
                L'acheter dans un autre magasin
              </Button>
            </p>
          </div>

          <template v-else-if="product.attributes.prix > 0">
            <AdvantagesContainer
              v-if="product.attributes.avantages !== null && product.attributes.avantages.length > 0 && !isPro"
              :component="ProductAdvantages"
              :advantages="product.attributes.avantages"
              :article="product"
              :cart-context="trackingCodes.LABELGA.FP"
              :available-quantity="product.attributes.qte_max_panier - quantity"
              class="u-mb-md@lg"
            />
            <div class="u-flex-item-fluid">
              <div v-if="isCarteKdo">
                <CarteKdoMontant
                  ref="ckdoForm"
                  :product="product"
                  @setPrice="setPriceCkdo"
                />
              </div>
              <Price
                v-else
                :amount="amount"
                :discount-rate="!isNational ? discountRate : null"
                :crossed-out-amount="!isNational ? formattedPrice(discountedAmount) : null"
                :prix-remise="product.attributes.prix_avec_remise_sans_appel_fidelite"
                :price-unit-reference="pricePerUnit"
                :is-buffet="isBuffet"
                :reference-unit="uniteRef"
                anchor-position="top-left"
                class="u-flex u-flex-column u-flex-align-end"
                size="lg"
              />
              <p
                v-if="product.attributes.eco_part"
                class="u-font-14 u-color-text-light u-text-right"
              >
                dont {{ formatPrix(product.attributes.eco_part) }}€ d'eco part
              </p>
              <p
                v-if="product.attributes.eco_mobilier"
                class="u-font-14 u-color-text-light u-text-right"
              >
                dont {{ formatPrix(product.attributes.eco_mobilier) }}€ d'eco mobilier
              </p>
              <p
                v-if="isLdd"
                class="u-font-14 u-color-text-light u-text-right"
              >
                frais de livraison inclus
              </p>
              <ProductDetailsMultipay
                v-if="product.attributes.eligible_fullcb"
                :product="product"
              />
              <client-only>
                <template v-if="!product.attributes.produit_non_vendable && !isReplacedByNational">
                  <ItemContainer
                    ref="itemContainer"
                    class="u-flex u-flex-justify-end u-flex-align-center u-mt-md"
                    :component="AddToCart"
                    :is-ckdo="isCarteKdo"
                    :prix="prixCKDO"
                    :article="product"
                    :pft-conf="product.attributes.pft_conf"
                    :is-pft="isPft"
                    :is-pro="isPro"
                    :is-buffet="isBuffet"
                    :cart-context="trackingCodes.LABELGA.FP"
                    :max-cart-qty="product.attributes.qte_max_panier"
                    :from-prospectus="fromProspectus"
                    @indexPoidsChanged="indexPoidsChanged"
                    @addToCart="$refs.ckdoForm.validate()"
                  />
                </template>
              </client-only>
            </div>
          </template>
        </div>
        <Alert
          v-if="product.attributes.produit_non_vendable && product.attributes.en_stock "
          class="u-mb-md"
        >
          <div class="u-text-center u-p-xs">
            <p class="u-font-500 u-font-18 u-mb-sm">
              <template v-if="isNational">
                Ce produit est disponible uniquement en magasin
              </template>
              <template v-else>
                Pour acheter cet article, rendez-vous dans votre magasin <br />
                de {{ shopName }}
              </template>
            </p>
            <div>
              <Button
                v-if="isNational"
                variant="primary"
                radius="full"
                size="sm"
                @click="$emit('openOrcloseStoreLocator')"
              >
                Voir les magasins proposant ce produit
              </Button>
              <Button
                v-else
                variant="primary"
                radius="full"
                size="sm"
                :to="`/magasins/${aliasWeb}-m-${shopId}`"
              >
                Voir la fiche magasin
              </Button>
            </div>
            <!-- <div
              v-if="!isNational"
              class="u-mt-sm"
            >
              <Button
                link
                variant="primary"
              >
                Acheter dans un autre magasin
              </Button>
            </div> -->
          </div>
        </Alert>
        <div class="u-clear"></div>
        <Divider
          dotted
          class="u-m-none"
        />
        <div class="c-product-detail__line">
          <div class="u-flex u-flex-align-center u-flex-justify-start u-flex-wrap u-gap-row-xs">
            <div
              v-if="product.attributes.with_consigne"
              class="u-flex u-flex-align-center"
            >
              <LazyImage
                :src="consigne"
                height="30"
                width="60"
                alt=""
                class="c-product-detail__stickers"
              />
              <p class="u-font-14 u-mr-xs">
                Pensez à ramener votre consigne vide pour l’échange de la bouteille
              </p>
            </div>

            <template v-if="product.attributes.origine">
              <Badge
                v-if="product.attributes.origine"
                class="u-font-26 u-text-uppercase"
              >
                <span> {{ product.attributes.origine }} </span>
              </Badge>
              <Divider
                v-if="characteristicsStickers.length > 0 && product.attributes.origine "
                vertical
                class="c-product-detail__line-divider"
              />
            </template>
            <template v-if="characteristicsStickers && characteristicsStickers.length>0">
              <List
                v-if="characteristicsStickers"
                class="c-product-detail__stickers"
              >
                <template
                  v-for="picto in characteristicsStickers"
                  :key="picto.alt"
                >
                  <ListItem
                    v-if="picto.code && url(picto.code)"
                    class="u-flex-shrink-none"
                  >
                    <PopinAnchor
                      popin-size="auto"
                      open-on-hover
                      position="top-right"
                      infobulle
                    >
                      <template #button-content>
                        <LazyImage
                          v-if="picto.code && url(picto.code)"
                          :src="url(picto.code)"
                          height="32"
                          width="32"
                          :alt="picto.alt"
                        />
                      </template>
                      <p class="u-font-14">
                        {{ picto.alt }}
                      </p>
                    </PopinAnchor>
                  </ListItem>
                </template>
              </List>
            </template>
            <template v-if="product.attributes.nutriscore !== null && product.attributes.nutriscore.url">
              <Divider
                v-if="(characteristicsStickers && characteristicsStickers.length>0) || product.attributes.origine"
                vertical
                class="c-product-detail__line-divider"
              />
              <NutriScore
                :alt="product.attributes.nutriscore.alt"
                width="60"
                height="32"
              />
            </template>
          </div>
        </div>
        <ShippingMethodEligibility
          v-if="showShippingMethodEligibility"
          :unavailable-services="product.attributes.unavailable_services"
          :jours-retraits="product.attributes.jours_retraits"
          class="u-flex u-flex-align-baseline u-flex-justify-end u-flex-item-fluid u-gap-xs"
          infobulle
          open-on-hover
          position="top-left"
        />
        <template v-if="product.attributes.prime_energie">
          <Divider dotted />
          <div class="c-product-detail__prime-energie u-mt-sm">
            <LazyImage
              :src="primeEnergie"
              width="80"
              alt="Cora Prime Energie"
              class="u-flex-shrink-none"
            />
            <div class="u-flex u-flex-column@md u-ml-sm">
              <p>Produit éligible à la prime énergie cora</p>
              <LinkTo
                v-if="product.attributes.prime_energie.prime_energie_lien"
                variant="primary"
                size="sm"
                class="u-ml-sm u-ml-none@md u-mt-xxs@md"
                :href="product.attributes.prime_energie.prime_energie_lien"
                target="_blank"
              >
                En savoir plus
                <Icon
                  name="external"
                  variant="primary"
                  size="xs"
                  class="u-ml-xxs u-flex-shrink-none"
                />
              </LinkTo>
            </div>
          </div>
          <div class="u-mt-md">
            <p class="u-font-15">
              {{ product.attributes.prime_energie.bonus_ecologique_texte }}
            </p>
            <LinkTo
              v-if="product.attributes.prime_energie.bonus_ecologique_lien"
              variant="grey-1"
              size="md"
              :href="product.attributes.prime_energie.bonus_ecologique_lien"
              target="_blank"
            >
              Conditions sur le site du ministère de l'économie
            </LinkTo>
          </div>
        </template>
        <ButtonIcon
          v-if="product.attributes.is_porteur_dlc"
          icon-name="info-circle"
          link
          variant="primary"
          icon-color="primary-light"
          icon-color-hover="primary-light"
          icon-size="xs"
          @click="$refs.popinDLC.show()"
        >
          Voir les dates limites de consommation garanties
        </ButtonIcon>
      </div>
    </div>
    <Popin
      v-if="product.attributes.is_porteur_dlc"
      ref="popinDLC"
      size="md"
      aria-label="Date limite de consommation"
    >
      <ReassuranceDLC />
    </Popin>
  </Container>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/product-details.scss";
</style>
